﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IPdfSectionField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.PdfSectionField, eOutputFieldType.pdfSection)
export class PdfSectionField extends OutputField implements IPdfSectionField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public source: string;
    public idQuoteOutput: number;
    public idTag: number;
    public filepaths: string[];
    public filePath: string;
    public sourceId: string;
    public nestedName: string;
    public nestedIdProduct: number;
    public selectedPages: string;
}
